import React from 'react'
import Header from '../commons/Header'
import Footer from '../commons/footer/Footer'
import SEO from '../commons/SEO'

const seoTitle = 'Pagina non trovata | QuintoPuoi'
const seoDescription = 'La pagina cercata non esiste o e stata spostata.'

const NotFound = () => {
  return (
    <>
      <SEO title={seoTitle} description={seoDescription}/>
      <Header/>
      <div style={{textAlign: 'start'}}>
        Sorry, we couldn't find what you're looking for.
      </div>
      <Footer/>
    </>
  )
}

export default NotFound
